import React, { FC } from 'react';
import { Grid } from '@mui/material';

export const Finance: FC = () => {
  return (
    <Grid container sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
      Finance
    </Grid>
  );
};

export default Finance;
